import React, { Component } from 'react';
import * as SimilarSeriesSelector from '../../data/SimilarSeriesSelectors';
import { SimilarSeriesCarousel, mapOtsAvailability } from '@novelist/novum-novella-ui';
import AnalyticsWrapperContainer from './AnalyticsWrapperContainer';
import { fetchSimilarSeriesData } from '../../data/SeriesSelectors';
import * as BooksInSeriesSelectors from '../../data/BooksInSeriesSelectors';
import { getSeriesDetailsOtsAvailablity } from '../../data/OtsRequests';
import { getAvailabilityConfiguration } from '../../data/DataStore';

class SimilarSeriesContainer extends Component {
	constructor(){
		super();
		
		this.state = {
			recommendedSeries: [],
			titlesInSeries: {},
		}
		this.postAction = this.postAction.bind(this);
		this.getTitlesInSeries = this.getTitlesInSeries.bind(this);
		this.initialRecomendedSeries = this.initialRecomendedSeries.bind(this);
		this.availabilityConfiguration = getAvailabilityConfiguration();
	}

	componentWillMount(){
		this.initialRecomendedSeries();
	}

	initialRecomendedSeries(){
		const seriesModel = SimilarSeriesSelector.getSimilarSeries();
		let recommendedSeries = seriesModel ? seriesModel.map((series) => {
			return {
				ui: series.uniqueId,
				mainTitle: series.title,
				author: series.authorName,
				recommendedReason: series.reasonText,
				bookjacketUrl: series.bookJacketUrl,
				novelistLinkUrl: series.linkToNovelistFullTarget
			}
		}): [];
		this.setState({ recommendedSeries: recommendedSeries });
	}
	
	setSimilarSeries(seriesUi, titles){		
		this.setState(prevState => ({
			titlesInSeries: { ...prevState.titlesInSeries, [seriesUi]: titles }
		}));
	}

	postAction(data, callBack, seriesUi){
		let titles = BooksInSeriesSelectors.getNovumTitlesInSeries(data);

		if(data && data.OtsResultRelativeUrl){
			Promise.resolve(getSeriesDetailsOtsAvailablity(data))
			.then((value) =>{
				titles.map(item =>{
					let otsDataForTitle = value && value.find(titleOts => {
						return titleOts.key === item.ui
					})
					item.availability = otsDataForTitle ? mapOtsAvailability(otsDataForTitle) : undefined;
				});
				this.setSimilarSeries(seriesUi, titles);
				callBack(titles);
			})
			.catch(err =>{
				this.setSimilarSeries(seriesUi, titles);
				callBack(titles);
			});
		}
		else{
			this.setSimilarSeries(seriesUi, titles);
			callBack(titles);
		}
	}

	getTitlesInSeries(seriesUi,callBack){
		if(this.state.titlesInSeries[seriesUi]){
			callBack(this.state.titlesInSeries[seriesUi]);
			return false;
		}
		else{
			fetchSimilarSeriesData(seriesUi, (data) => this.postAction(data, callBack, seriesUi));
			return true;
		}
	}

	render(){
		if(this.state.recommendedSeries.length){
			return (<AnalyticsWrapperContainer
				Component={<SimilarSeriesCarousel recommendedSeries={this.state.recommendedSeries} getTitlesInSeries={this.getTitlesInSeries} availabilityConfiguration={this.availabilityConfiguration} />}
				componentName={'Similar Series'}
				featureType={'Series Read-alikes'}
			/>);
		}
		else{
			return null;
		}
	}
}

export default SimilarSeriesContainer;



// WEBPACK FOOTER //
// ./src/react/containers/SimilarSeriesCarouselContainer.jsx